import React, { useCallback, useEffect, useState } from 'react'
import { Badge, Card, Form, Spinner, Table } from '@themesberg/react-bootstrap'
import { getAllChannel, updateChannel } from '../../../../controller/api/__classic__/channel';
import { useCookies } from 'react-cookie';

const WEEKDAYS = [
  { code: 'Mon', short: 'T2' },
  { code: 'Tue', short: 'T3' },
  { code: 'Wed', short: 'T4' },
  { code: 'Thu', short: 'T5' },
  { code: 'Fri', short: 'T6' },
  { code: 'Sat', short: 'T7' },
  { code: 'Sun', short: 'CN' },
]

const ChannelRow = ({ channel, onChange, saving }) => {
  const { id, name, weekdays = [], status } = channel
  const isActive = status === 1
  const cellId = (code) => `cell-${id}-${code}`

  return (
    <tr>
      <td className="text-danger align-middle" style={{ whiteSpace: 'nowrap' }}>
        <strong>{id}</strong>
      </td>
      <td className="align-middle">{name || ''}</td>
      {WEEKDAYS.map(wd => {
        const checked = weekdays.includes(wd.code)
        return (
          <td key={wd.code} className="text-center align-middle">
            <Form.Check
              type="checkbox"
              id={cellId(wd.code)}
              checked={checked}
              disabled={saving}
              onChange={() => onChange(channel, {
                weekdays: checked
                  ? weekdays.filter(it => it !== wd.code)
                  : [...weekdays, wd.code],
              })}
            />
          </td>
        )
      })}
      <td className="text-center align-middle">
        <Form.Check
          type="switch"
          id={`status-${id}`}
          checked={isActive}
          disabled={saving}
          onChange={() => onChange(channel, { status: isActive ? 0 : 1 })}
          label={
            isActive
              ? <Badge bg="success">Hoạt động</Badge>
              : <Badge bg="secondary">Tắt</Badge>
          }
        />
      </td>
    </tr>
  )
}

export const ChannelTable = ({ region }) => {
  const [channels, setChannels] = useState([])
  const [savingId, setSavingId] = useState(null)
  const [error, setError] = useState('')

  const [cookies] = useCookies(['lottmekong'])

  const fetchChannels = useCallback(async () => {
    const list = await getAllChannel(cookies.lottmekong, region)
    if (list && Array.isArray(list.data)) {
      setChannels(list.data)
    }
  }, [cookies.lottmekong, region])

  useEffect(() => {
    fetchChannels()
  }, [fetchChannels])

  const handleChange = async (channel, patch) => {
    const prev = channels
    const optimistic = channels.map(c =>
      c.id === channel.id ? { ...c, ...patch } : c
    )
    setChannels(optimistic)
    setSavingId(channel.id)
    setError('')

    const next = optimistic.find(c => c.id === channel.id)
    const resp = await updateChannel(cookies.lottmekong, {
      id: channel.id,
      weekdays: next.weekdays,
      status: Number(next.status),
    })

    setSavingId(null)
    if (!resp || resp.status !== 'success') {
      setChannels(prev)
      setError(`Lưu thất bại cho đài ${channel.id}`)
    }
  }

  return (
    <Card border="light" className="shadow-sm">
      {error && (
        <div className="alert alert-danger m-3 mb-0 py-2">{error}</div>
      )}
      <Table responsive hover className="align-items-center table-flush mb-0">
        <thead className="thead-light">
          <tr>
            <th scope="col">Mã</th>
            <th scope="col">Tên đài</th>
            {WEEKDAYS.map(wd => (
              <th key={wd.code} scope="col" className="text-center">{wd.short}</th>
            ))}
            <th scope="col" className="text-center">
              Trạng thái {savingId !== null && <Spinner size="sm" animation="border" className="ms-2" />}
            </th>
          </tr>
        </thead>
        <tbody>
          {channels.map(c => (
            <ChannelRow
              key={`channel-${c.id}`}
              channel={c}
              saving={savingId === c.id}
              onChange={handleChange}
            />
          ))}
        </tbody>
      </Table>
    </Card>
  )
}
